/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { useState, useEffect } from 'react'
interface IPropsInputGroup {
  inputName: string
  returnInputValue: any
  labelText?: string
  placeholderText?: string
  maxValue?: string | number
  minValue?: string | number
  bindValue?: string
  inputValueSuffix?: string
  responseError?: string
  suffix?: string
  prefix?: string
}

const InputGroup: React.FC<IPropsInputGroup> = ({
  labelText,
  inputName,
  placeholderText,
  returnInputValue,
  maxValue,
  minValue,
  bindValue,
  inputValueSuffix,
  responseError,
  suffix,
  prefix,
}) => {
  const [value, setValue] = useState<string>(
    bindValue ? (inputValueSuffix ? `${bindValue}${inputValueSuffix}` : bindValue) : '0',
  )
  const [minValueError, setMinValueError] = useState<boolean>(false)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement> | any) => {
    const clearInputValue = inputValueSuffix
      ? e.target.value.replace(inputValueSuffix, '').replaceAll(' ', '')
      : e.target.value.replaceAll(' ', '')

    setValue(`${clearInputValue}${inputValueSuffix || ''}`)
  }

  const checkValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    const clearInputValue = inputValueSuffix
      ? e.target.value.replace(inputValueSuffix, '').replaceAll(' ', '')
      : e.target.value.replaceAll(' ', '')

    let temp: string | number =
      parseInt(clearInputValue) < 0 ? '0' : clearInputValue.trim() === '' ? '0' : clearInputValue

    if (maxValue && parseInt(temp) >= parseInt(String(maxValue))) temp = maxValue

    if (minValue !== undefined && parseInt(String(temp)) > parseInt(String(minValue))) {
      setMinValueError(false)
      setValue(`${temp}`)
    } else {
      setMinValueError(true)
    }
  }

  useEffect(() => {
    if (value === '') return
    returnInputValue(inputName, value)
  }, [value])

  useEffect(() => {
    if (!bindValue) return

    const obj: any = {
      target: {
        value: bindValue,
      },
    }
    handleChange(obj)
  }, [bindValue])

  return (
    <div className='InputGroup'>
      <div className='InputGroup__labelWrapper'>
        <label className='InputGroup__labelWrapper--label' htmlFor={inputName}>
          {labelText}
        </label>

        <If condition={minValueError}>
          <div className='InputGroup__labelWrapper--text'>
            Please ensure your {inputName} is more than £0.
          </div>
        </If>

        <If condition={Boolean(responseError)}>
          <div className='InputGroup__labelWrapper--errorText'>{responseError}</div>
        </If>
      </div>

      <div
        className='InputGroup__tableCell'
        style={minValueError ? { border: '2px solid #d64226' } : { border: 'solid 2px #e9ebed' }}
      >
        <If condition={Boolean(prefix)}>
          <span className='InputGroup__tableCell--prefix'>{prefix}</span>
        </If>

        <input
          className='InputGroup__tableCell--input'
          type='number'
          value={value}
          placeholder={placeholderText}
          name={inputName}
          onFocus={() => {
            setValue('')
          }}
          onBlur={checkValue}
          onChange={handleChange}
        />

        <If condition={Boolean(suffix)}>
          <span className='InputGroup__tableCell--suffix'>{suffix}</span>
        </If>
      </div>
    </div>
  )
}
export default InputGroup
